(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3982],{

/***/ 1027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/study-abroad-scholarships/[slug]",
      function () {
        return __webpack_require__(70829);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76604);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14523);





const Banner = ({ children , bannerData , bgInverted =false , bannerStyles ={} , imageWrapperStyles ={}  })=>{
    const isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(768);
    const bannerImageData = !isMobile ? bannerData?.priorityImage : bannerData?.priorityImageMobile;
    const { 0: aspectRatio , 1: setAspectRatio  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAspectRatio(null);
        const url = bannerImageData?.url;
        if (isMobile || !url) return;
        const img = new window.Image();
        const onLoad = ()=>{
            if (img.naturalWidth && img.naturalHeight) {
                setAspectRatio(img.naturalWidth / img.naturalHeight);
            }
        };
        img.addEventListener("load", onLoad);
        img.src = url;
        return ()=>img.removeEventListener("load", onLoad);
    }, [
        bannerImageData?.url,
        isMobile
    ]);
    const imageClickHandler = (url)=>()=>{
            window.open(url ?? "", "_blank");
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: bannerImageData?.url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["image-wrapper"]),
            style: {
                background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)",
                ...imageWrapperStyles
            },
            onClick: imageClickHandler(bannerData?.priorityImageUrl ?? ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["priority-image-container"]),
                style: !isMobile && aspectRatio ? {
                    aspectRatio: String(aspectRatio),
                    height: "auto"
                } : undefined,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: bannerImageData?.url ?? "/images/man_with_foldedhands.png",
                    alt: bannerData?.title ?? "banner-image",
                    layout: "fill",
                    objectFit: isMobile ? "fill" : "contain",
                    className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["priority-image"]),
                    priority: true,
                    isLazyLoad: false
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["banner-container-wrapper"]),
            style: {
                background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["banner-container"]),
                style: bannerStyles,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 46412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79373);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ErrorComponent = (props)=>{
    const { serverError  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        function randomNum() {
            "use strict";
            return Math.floor(Math.random() * 9) + 1;
        }
        let increaseTimer = 0;
        const time = 30, selector3 = document.querySelector(".thirdDigit"), selector2 = document.querySelector(".secondDigit"), selector1 = document.querySelector(".firstDigit");
        const loop3 = setInterval(function() {
            "use strict";
            if (increaseTimer > 40) {
                clearInterval(loop3);
                if (selector3) selector3.textContent = serverError ? "5" : "4";
            } else {
                if (selector3) selector3.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop2 = setInterval(function() {
            "use strict";
            if (increaseTimer > 80) {
                clearInterval(loop2);
                if (selector2) selector2.textContent = "0";
            } else {
                if (selector2) selector2.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop1 = setInterval(function() {
            "use strict";
            if (increaseTimer > 100) {
                clearInterval(loop1);
                if (selector1) selector1.textContent = serverError ? "0" : "4";
            } else {
                if (selector1) selector1.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "error-component",
        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-12 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerError404),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} thirdDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} secondDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} firstDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().msg),
                                    children: [
                                        "OH!",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().triangle)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "h1",
                            children: "OOPS, SORRY WE CAN'T FIND THAT PAGE!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Either something went wrong or the page doesn't exist anymore."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btndiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnPrimary)}`,
                                    children: "Back to home"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 78808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _CountryDetail_Banner_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74623);
/* harmony import */ var _Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85307);
/* harmony import */ var _Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45992);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);






function Banner1({ bannerData  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["banner-section-wrapper"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["banner-container"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CountryDetail_Banner_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                bannerData: bannerData,
                imageWrapperStyles: {
                    margin: "0"
                },
                bannerStyles: {
                    backgroundColor: "#6C48F0",
                    width: "100%",
                    margin: "-80px 0"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["banner-1-container"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["content-container"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: bannerData?.title ?? ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["actions-container"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["kc-letter-container"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        src: "/icons/kc_union.svg",
                                        height: 187,
                                        width: 325,
                                        alt: "kc-overseas-icon",
                                        objectFit: "fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: `${(_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["contact-us-btn"])} ${bannerData?.button1?.btnLink ? "" : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(bannerData?.button1?.formId ?? "")}`,
                                    onClick: ()=>{
                                        bannerData?.button1?.btnLink && window.open(bannerData?.button1?.btnLink, "_blank");
                                    },
                                    children: bannerData?.button1?.btnTitle ?? ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: `${(_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["enquire-now-btn"])} ${bannerData?.button2?.btnLink ? "" : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(bannerData?.button2?.formId ?? "")}`,
                                    onClick: ()=>{
                                        bannerData?.button2?.btnLink && window.open(bannerData?.button2?.btnLink, "_blank");
                                    },
                                    children: bannerData?.button2?.btnTitle ?? ""
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Banner1);


/***/ }),

/***/ 57866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20252);
/* harmony import */ var _FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _UI_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33434);




const FAQs = ({ faqData  })=>{
    const accordionItems = (faqData?.faqPoints ?? []).map((faq)=>({
            title: faq.title,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: faq.description
                }
            })
        }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-section"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-container"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-heading"]),
                    children: faqData?.title ?? ""
                }),
                faqData?.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-subtext"]),
                    dangerouslySetInnerHTML: {
                        __html: faqData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    items: accordionItems,
                    defaultOpenIndex: 0,
                    theme: "base",
                    icon: "plus"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQs);


/***/ }),

/***/ 64171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56303);
/* harmony import */ var _ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14523);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89382);






const ReceviedScholarships = ({ topScholarships  })=>{
    const isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(768);
    const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        loop: false,
        align: "start"
    });
    const { 0: selectedIndex , 1: setSelectedIndex  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { 0: scrollSnaps , 1: setScrollSnaps  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!emblaApi) return;
        const onSelect = ()=>setSelectedIndex(emblaApi.selectedScrollSnap());
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
        onSelect();
        return ()=>{
            emblaApi.off("select", onSelect);
            emblaApi.off("reInit", onSelect);
        };
    }, [
        emblaApi
    ]);
    const goToPrev = ()=>emblaApi?.scrollPrev();
    const goToNext = ()=>emblaApi?.scrollNext();
    const goToSnap = (index)=>emblaApi?.scrollTo(index);
    const arrowLeft = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow"]),
        onClick: goToPrev,
        "aria-label": "Previous",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "left-arrow"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow"]),
        onClick: goToNext,
        "aria-label": "Next",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "right-arrow"
        })
    });
    const renderCards = ()=>topScholarships?.ourStudentsAchievements?.map((recipient)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-slide"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-card"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-avatar-wrap"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: recipient.studentImageUrl || "/new-images/for-student.svg",
                                alt: recipient.name,
                                width: 160,
                                height: 160,
                                objectFit: "cover",
                                className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-avatar"])
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-name"]),
                            children: recipient.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-details"]),
                            children: recipient?.points?.length > 0 && recipient?.points?.map((point)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-label"]),
                                            children: [
                                                point.label,
                                                " :"
                                            ]
                                        }),
                                        " ",
                                        point.value
                                    ]
                                }))
                        })
                    ]
                })
            }, recipient.id));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-section"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-container"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-heading"]),
                    children: topScholarships?.title ?? ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-carousel-wrap"]),
                    children: [
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow-side"]),
                            children: arrowLeft
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-viewport"]),
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-slider"]),
                                children: renderCards()
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow-side"]),
                            children: arrowRight
                        })
                    ]
                }),
                isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrows-below"]),
                    children: [
                        arrowLeft,
                        arrowRight
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-dots"]),
                    children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: `${(_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-dot"])} ${index === selectedIndex ? (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-dot-active"]) : ""}`,
                            onClick: ()=>goToSnap(index),
                            "aria-label": `Go to slide ${index + 1}`
                        }, index))
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReceviedScholarships);


/***/ }),

/***/ 67316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const DollarEnclosed = ({ width =20 , height =20 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.50175 19C8.18775 19 6.95267 18.7507 5.7965 18.252C4.64033 17.7533 3.63467 17.0766 2.7795 16.2218C1.92433 15.3669 1.24725 14.3617 0.74825 13.206C0.249417 12.0503 0 10.8156 0 9.50175C0 8.18775 0.249333 6.95267 0.748 5.7965C1.24667 4.64033 1.92342 3.63467 2.77825 2.7795C3.63308 1.92433 4.63833 1.24725 5.794 0.74825C6.94967 0.249417 8.18442 0 9.49825 0C10.8123 0 12.0473 0.249333 13.2035 0.748C14.3597 1.24667 15.3653 1.92342 16.2205 2.77825C17.0757 3.63308 17.7528 4.63833 18.2518 5.794C18.7506 6.94967 19 8.18442 19 9.49825C19 10.8123 18.7507 12.0473 18.252 13.2035C17.7533 14.3597 17.0766 15.3653 16.2218 16.2205C15.3669 17.0757 14.3617 17.7528 13.206 18.2518C12.0503 18.7506 10.8156 19 9.50175 19ZM9.5 17.5C11.7333 17.5 13.625 16.725 15.175 15.175C16.725 13.625 17.5 11.7333 17.5 9.5C17.5 7.26667 16.725 5.375 15.175 3.825C13.625 2.275 11.7333 1.5 9.5 1.5C7.26667 1.5 5.375 2.275 3.825 3.825C2.275 5.375 1.5 7.26667 1.5 9.5C1.5 11.7333 2.275 13.625 3.825 15.175C5.375 16.725 7.26667 17.5 9.5 17.5ZM9.95275 16.1028C10.0894 15.9663 10.1578 15.807 10.1578 15.625V15.0962C10.9334 14.9911 11.6357 14.6997 12.2645 14.222C12.8933 13.7445 13.2078 13.0205 13.2078 12.05C13.2078 11.35 13.0013 10.7308 12.5885 10.1923C12.1757 9.65392 11.3692 9.16808 10.1692 8.73475C9.11792 8.37575 8.41983 8.06483 8.075 7.802C7.73017 7.53917 7.55775 7.17183 7.55775 6.7C7.55775 6.22817 7.73433 5.84483 8.0875 5.55C8.44067 5.25517 8.92817 5.10775 9.55 5.10775C9.92183 5.10775 10.2472 5.17725 10.526 5.31625C10.8048 5.45542 11.0404 5.641 11.2327 5.873C11.3546 6.02183 11.4956 6.12567 11.6557 6.1845C11.8161 6.2435 11.9678 6.241 12.111 6.177C12.3065 6.1 12.4401 5.96858 12.5117 5.78275C12.5834 5.59675 12.5654 5.42625 12.4578 5.27125C12.1911 4.89425 11.8603 4.58042 11.4653 4.32975C11.0704 4.07908 10.6512 3.93708 10.2078 3.90375V3.375C10.2078 3.193 10.1394 3.03375 10.0027 2.89725C9.86625 2.76058 9.707 2.69225 9.525 2.69225C9.343 2.69225 9.18375 2.76058 9.04725 2.89725C8.91058 3.03375 8.84225 3.193 8.84225 3.375V3.90375C7.98975 4.06792 7.335 4.41375 6.878 4.94125C6.42083 5.46892 6.19225 6.05517 6.19225 6.7C6.19225 7.45133 6.41983 8.05583 6.875 8.5135C7.33017 8.97117 8.07183 9.38458 9.1 9.75375C10.1628 10.1436 10.8888 10.4933 11.278 10.803C11.667 11.1125 11.8615 11.5282 11.8615 12.05C11.8615 12.677 11.6353 13.1324 11.1827 13.4163C10.7301 13.7003 10.2192 13.8422 9.65 13.8422C9.175 13.8422 8.74567 13.7237 8.362 13.4865C7.97833 13.2493 7.657 12.9064 7.398 12.4578C7.29683 12.2821 7.16033 12.1638 6.9885 12.103C6.81667 12.042 6.6485 12.0439 6.484 12.1088C6.30667 12.1736 6.17683 12.2967 6.0945 12.478C6.01233 12.6593 6.01158 12.8327 6.09225 12.998C6.37175 13.5583 6.7365 14.0064 7.1865 14.3422C7.6365 14.6783 8.17175 14.9129 8.79225 15.0462V15.625C8.79225 15.807 8.86058 15.9663 8.99725 16.1028C9.13375 16.2394 9.293 16.3078 9.475 16.3078C9.657 16.3078 9.81625 16.2394 9.95275 16.1028Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DollarEnclosed);


/***/ }),

/***/ 31331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const FeatherNote = ({ width =20 , height =20 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 19 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.87494 14.846C5.46244 14.846 5.10928 14.6992 4.81544 14.4055C4.52178 14.1117 4.37494 13.7585 4.37494 13.346V11.75C4.37494 11.4938 4.46153 11.2792 4.63469 11.106C4.80803 10.9328 5.02269 10.8463 5.27869 10.8463H7.25944V8.096C6.73378 8.13333 6.19628 8.0805 5.64694 7.9375C5.09761 7.7945 4.62036 7.54158 4.21519 7.17875C4.12119 7.08792 4.04669 6.98575 3.99169 6.87225C3.93686 6.75875 3.90944 6.6385 3.90944 6.5115V5.65375H3.00169C2.88403 5.65375 2.77003 5.632 2.65969 5.5885C2.54936 5.54483 2.44769 5.47658 2.35469 5.38375L0.264944 3.294C0.079277 3.10817 -0.00880636 2.89158 0.000693638 2.64425C0.0103603 2.39675 0.112027 2.18583 0.305694 2.0115C0.789027 1.59867 1.39094 1.29417 2.11144 1.098C2.83194 0.901834 3.51461 0.803751 4.15944 0.803751C4.70494 0.803751 5.23519 0.866 5.75019 0.9905C6.26536 1.11483 6.76844 1.31992 7.25944 1.60575V1.423C7.25944 1.02633 7.39744 0.69 7.67344 0.414C7.94944 0.138 8.28578 0 8.68244 0H16.4562C16.9519 0 17.3764 0.177001 17.7297 0.531001C18.0829 0.885001 18.2594 1.31058 18.2594 1.80775V12.346C18.2594 13.0448 18.0174 13.6362 17.5334 14.12C17.0494 14.604 16.4581 14.846 15.7594 14.846H5.87494ZM8.75944 10.8463H13.8749C14.1198 10.8463 14.3284 10.9324 14.5007 11.1048C14.6732 11.2773 14.7594 11.4859 14.7594 11.7308V12.346C14.7594 12.6293 14.8553 12.8668 15.0469 13.0585C15.2386 13.2502 15.4761 13.346 15.7594 13.346C16.0428 13.346 16.2803 13.2502 16.4719 13.0585C16.6636 12.8668 16.7594 12.6293 16.7594 12.346V1.80775C16.7594 1.71792 16.7306 1.64417 16.6729 1.5865C16.6153 1.52883 16.5415 1.5 16.4517 1.5H9.06719C8.97736 1.5 8.90361 1.52883 8.84594 1.5865C8.78828 1.64417 8.75944 1.71792 8.75944 1.80775V2.6L14.3017 8.14225C14.4162 8.25442 14.4862 8.38217 14.5117 8.5255C14.537 8.66867 14.5184 8.80975 14.4557 8.94875C14.3929 9.08792 14.3049 9.1985 14.1917 9.2805C14.0787 9.36267 13.9342 9.40375 13.7582 9.40375C13.6577 9.40375 13.5606 9.38208 13.4669 9.33875C13.3731 9.29542 13.2949 9.24275 13.2324 9.18075L10.5094 6.45775L10.1267 6.84025C9.91269 7.05442 9.69411 7.24033 9.47094 7.398C9.24794 7.55567 9.01078 7.6845 8.75944 7.7845V10.8463ZM3.26319 4.15375H4.50569C4.76169 4.15375 4.97636 4.24042 5.14969 4.41375C5.32286 4.58692 5.40944 4.80158 5.40944 5.05775V6.20775C5.67994 6.37958 5.94278 6.49683 6.19794 6.5595C6.45311 6.62233 6.70828 6.65375 6.96344 6.65375C7.38261 6.65375 7.76236 6.58583 8.10269 6.45C8.44303 6.31417 8.76961 6.08983 9.08244 5.777L9.45569 5.40375L7.88244 3.83075C7.37344 3.32175 6.80294 2.94 6.17094 2.6855C5.53894 2.431 4.86844 2.30375 4.15944 2.30375C3.74911 2.30375 3.35394 2.348 2.97394 2.4365C2.59378 2.525 2.23761 2.64492 1.90544 2.79625L3.26319 4.15375ZM13.2594 12.346H5.87494V13.346H13.4864C13.4044 13.2025 13.3461 13.0463 13.3114 12.8775C13.2768 12.7088 13.2594 12.5317 13.2594 12.346Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatherNote);


/***/ }),

/***/ 31010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Kunai = ({ width =20 , height =20 , color ="#ffffff"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.34317 0.633099C7.6761 -0.211047 8.87078 -0.211046 9.2037 0.633099L10.9425 5.04193C11.0442 5.29965 11.2482 5.50366 11.5059 5.6053L15.9147 7.34412C16.7589 7.67705 16.7589 8.87172 15.9147 9.20465L11.5059 10.9435C11.2482 11.0451 11.0442 11.2491 10.9425 11.5068L9.2037 15.9157C8.87078 16.7598 7.6761 16.7598 7.34317 15.9157L5.60436 11.5068C5.50271 11.2491 5.29871 11.0451 5.04098 10.9435L0.632153 9.20465C-0.211993 8.87172 -0.211993 7.67705 0.632153 7.34412L5.04098 5.6053C5.29871 5.50366 5.50271 5.29965 5.60436 5.04193L7.34317 0.633099Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Kunai);


/***/ }),

/***/ 63098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28154);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Spinner = ({ width =40 , height =40  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().spinner),
        style: {
            width,
            height
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useDebounce.ts

/**
 * Returns a debounced version of `callback` that delays invoking it until
 * `delay` milliseconds have passed since the last call. The returned function
 * keeps a stable identity across renders, and any pending call is cancelled
 * on unmount.
 *
 * @param callback The function to debounce.
 * @param delay Delay in milliseconds (defaults to 500ms).
 */ const useDebounce = (callback, delay = 500)=>{
    const timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    // Keep the latest callback without changing the debounced function's identity.
    const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const debounced = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const fn = (...args)=>{
            if (timer.current) {
                clearTimeout(timer.current);
            }
            timer.current = setTimeout(()=>{
                callbackRef.current(...args);
            }, delay);
        };
        fn.cancel = ()=>{
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
        return fn;
    }, [
        delay
    ]);
    // Cancel any pending invocation on unmount.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>debounced.cancel(), [
        debounced
    ]);
    return debounced;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 70829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ErrorComponent.tsx
var ErrorComponent = __webpack_require__(46412);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./styles/ScholarshipsCountry.module.scss
var ScholarshipsCountry_module = __webpack_require__(76817);
var ScholarshipsCountry_module_default = /*#__PURE__*/__webpack_require__.n(ScholarshipsCountry_module);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/StudyAbroad/PopularSholarshipPrograms.tsx













const CountryPopularSholarshipProgramsComponent = (props)=>{
    const scholarshipCountryData = props.pageData[0];
    const renderPaginationItem = (index, active)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${active ? "active" : ""}`,
            children: index + 1
        });
    };
    const sliderRef = (0,react.useRef)(null);
    const slidersettings = {
        dots: true,
        dotsClass: (ScholarshipsCountry_module_default()).sliderDots,
        infinite: true,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 6,
        customPaging: (index)=>renderPaginationItem(index, true),
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    rows: 2
                }
            }, 
        ]
    };
    const mobileSliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: (ScholarshipsCountry_module_default()).mobileSliderDots,
        arrows: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ScholarshipsCountry_module_default()).scholarshipPrograms,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: scholarshipCountryData?.scholarshipsPrograms?.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "d-none d-sm-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ScholarshipsCountry_module_default()).sliderPosition,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                    ...slidersettings,
                                    ref: sliderRef,
                                    children: scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms?.length > 0 && scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms.map((programsData, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ScholarshipsCountry_module_default()).programSlider,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                className: (ScholarshipsCountry_module_default()).card,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                                    className: (ScholarshipsCountry_module_default()).cardBody,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                xl: 4,
                                                                lg: 4,
                                                                md: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (ScholarshipsCountry_module_default()).program,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (ScholarshipsCountry_module_default()).cardImg,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: programsData?.image?.url,
                                                                                width: 100,
                                                                                height: 100,
                                                                                alt: programsData?.image?.alternativeText,
                                                                                className: (ScholarshipsCountry_module_default()).borderRadiusImg
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (ScholarshipsCountry_module_default()).content,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: programsData.subTitle
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                xl: 6,
                                                                lg: 6,
                                                                md: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (ScholarshipsCountry_module_default()).detail,
                                                                    children: programsData?.programs?.length > 0 && programsData?.programs.map((data, index)=>{
                                                                        let programList = data.split(":");
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        programList[0],
                                                                                        " :"
                                                                                    ]
                                                                                }),
                                                                                programList[1]
                                                                            ]
                                                                        }, index);
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                xl: 2,
                                                                lg: 2,
                                                                md: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (ScholarshipsCountry_module_default()).applyNow,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}  ${(ScholarshipsCountry_module_default()).viewMore}`,
                                                                        children: "Enquire Now"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }, index);
                                    })
                                }),
                                scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms?.length > 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ScholarshipsCountry_module_default()).arrowsClass,
                                    style: {
                                        width: `${Math.ceil(scholarshipCountryData.scholarshipsPrograms.popularCountryPrograms.length / 6) * 100}px`,
                                        maxWidth: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: `${(ScholarshipsCountry_module_default()).btcircle} ${(ScholarshipsCountry_module_default()).floatLeft}`,
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: `${(ScholarshipsCountry_module_default()).btcircle} ${(ScholarshipsCountry_module_default()).floatRight}`,
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "d-block d-sm-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ScholarshipsCountry_module_default()).sliderPosition,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...mobileSliderSettings,
                                children: scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms?.length > 0 && scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms.map((programsData, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ScholarshipsCountry_module_default()).programSlider,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                            className: (ScholarshipsCountry_module_default()).mobileCard,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                className: (ScholarshipsCountry_module_default()).mobileCardBody,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (ScholarshipsCountry_module_default()).mobileCardHeader,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (ScholarshipsCountry_module_default()).cardImg,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: programsData?.image?.url,
                                                                    width: 100,
                                                                    height: 100,
                                                                    alt: programsData?.image?.alternativeText,
                                                                    className: (ScholarshipsCountry_module_default()).borderRadiusImg
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (ScholarshipsCountry_module_default()).content,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: programsData.subTitle
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ScholarshipsCountry_module_default()).mobileProgramDetails,
                                                        children: programsData?.programs?.length > 0 && programsData?.programs.map((data, index)=>{
                                                            let programList = data.split(":");
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            programList[0],
                                                                            " :"
                                                                        ]
                                                                    }),
                                                                    programList[1]
                                                                ]
                                                            }, index);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ScholarshipsCountry_module_default()).applyNow,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}  ${(ScholarshipsCountry_module_default()).viewMore}`,
                                                            children: "Enquire Now"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var PopularSholarshipPrograms = (CountryPopularSholarshipProgramsComponent);

// EXTERNAL MODULE: ./components/StudentsAcheivement.tsx
var StudentsAcheivement = __webpack_require__(32892);
// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
;// CONCATENATED MODULE: ./components/StudyAbroad/ScholarshipCountryComponent.tsx















const StudyAbroadScholarshipCountryComponent = (props)=>{
    const scholarshipCountryData = props.pageData[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "countrySholarshipsPage",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "countrySholarshipsBanner",
                    className: (ScholarshipsCountry_module_default()).countrySholarshipsPage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ScholarshipsCountry_module_default()).breadcrum,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            lg: 8,
                                            md: 8,
                                            xs: 12,
                                            className: (ScholarshipsCountry_module_default()).centered,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            style: {
                                                                opacity: 0.5
                                                            },
                                                            href: "/student-services/steps-to-study-abroad",
                                                            children: "Services for Students"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            style: {
                                                                opacity: 0.5
                                                            },
                                                            href: "./",
                                                            children: "Scholarships"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: [
                                                                scholarshipCountryData.scholarships_country?.countryName,
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ScholarshipsCountry_module_default()).abttopContent,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: scholarshipCountryData.bannerSection?.title
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                className: (ScholarshipsCountry_module_default()).parentMain,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    lg: 12,
                                                    xs: 12,
                                                    md: 12,
                                                    sm: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-none d-sm-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: scholarshipCountryData.bannerSection?.desktopBannerImage?.url,
                                                                width: 1100,
                                                                height: 300,
                                                                alt: scholarshipCountryData.bannerSection?.desktopBannerImage?.alternativeText,
                                                                className: (ScholarshipsCountry_module_default()).borderRadiusImg
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-block d-sm-none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: scholarshipCountryData.bannerSection?.mobileBannerImage?.url,
                                                                width: 341,
                                                                height: 300,
                                                                alt: scholarshipCountryData.bannerSection?.mobileBannerImage?.alternativeText,
                                                                className: (ScholarshipsCountry_module_default()).borderRadiusImg
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ScholarshipsCountry_module_default()).introduction,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "justify-content-center text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xl: 8,
                                        lg: 8,
                                        md: 10,
                                        sm: 12,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ScholarshipsCountry_module_default()).para,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: scholarshipCountryData.bannerSection?.description
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                id: "applyNowBtn",
                                                variant: "primary",
                                                size: "lg",
                                                className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}  ${(ScholarshipsCountry_module_default()).applyNow}`,
                                                children: [
                                                    " ",
                                                    "Enquire Now",
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "popularScholarshipPrograms",
                    className: (ScholarshipsCountry_module_default()).popularScholarshipPrograms,
                    style: {
                        backgroundColor: scholarshipCountryData?.ScholarshipsPrograms?.SectionBgColor
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSholarshipPrograms, {
                        ...props
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "scholarshipAchievement",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudentsAcheivement/* default */.Z, {
                        slug: `our-students-achievements?type=scholarship&scholarships_country.countryName=${scholarshipCountryData.scholarships_country.countryName}`
                    })
                }),
                scholarshipCountryData && scholarshipCountryData?.sscVideoTestimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "testimonials",
                    style: {
                        marginTop: "40px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                        ...scholarshipCountryData.sscVideoTestimonials
                    })
                }),
                scholarshipCountryData && scholarshipCountryData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                    ...scholarshipCountryData.faq
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "needGuidance",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                        classname: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}`
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ScholarshipCountryComponent = (StudyAbroadScholarshipCountryComponent);

// EXTERNAL MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/HeroSection/HeroSection.module.scss
var HeroSection_module = __webpack_require__(26666);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./components/UI/Icons/Kunai.tsx
var Kunai = __webpack_require__(31010);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/HeroSection/HeroSection.tsx






const HeroSection = ({ scholarshipCountryData  })=>{
    const heroSectionData = scholarshipCountryData?.heroSection ?? {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "countrySholarshipsBanner",
        className: (HeroSection_module_default()).countrySholarshipsPage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default())["breadcrum-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                            style: {
                                opacity: 0.5
                            },
                            href: "/",
                            children: "Home"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                            href: "/student-services/study-abroad-scholarships",
                            children: "Scholarships"
                        }),
                        scholarshipCountryData?.scholarships_country?.countryName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                            href: "",
                            children: scholarshipCountryData?.scholarships_country?.countryName ?? ""
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (HeroSection_module_default()).heading,
                children: heroSectionData?.title ?? ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: heroSectionData?.description ?? ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: `${(HeroSection_module_default()).ctaBtn} ${heroSectionData?.ctaBtn?.btnLink ? "" : (0,helpers/* isFrappeOrJotFormClass */.gd)(heroSectionData?.ctaBtn?.formId ?? "")}`,
                onClick: ()=>{
                    heroSectionData?.ctaBtn?.btnLink && window.open(heroSectionData?.ctaBtn?.btnLink, "_blank");
                },
                children: heroSectionData?.ctaBtn?.btnTitle ?? ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).kunai1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Kunai/* default */.Z, {
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).kunai2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Kunai/* default */.Z, {
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).kunai3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Kunai/* default */.Z, {
                    width: 20,
                    height: 20,
                    color: "#ffffff80"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).dot1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).dot2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default())["empty-circle"]
            })
        ]
    });
};
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/ScholarshipList/ScholarshipList.module.scss
var ScholarshipList_module = __webpack_require__(69122);
var ScholarshipList_module_default = /*#__PURE__*/__webpack_require__.n(ScholarshipList_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/ScholarshipList/FilterCard/FilterCard.module.scss
var FilterCard_module = __webpack_require__(50865);
var FilterCard_module_default = /*#__PURE__*/__webpack_require__.n(FilterCard_module);
// EXTERNAL MODULE: ./components/UI/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(20052);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./components/UI/Icons/CrossIcon.tsx
var CrossIcon = __webpack_require__(30535);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/ScholarshipList/FilterCard/FilterCard.tsx








const FilterCard = ({ setScholarships , setSearchedUni , setLoading  })=>{
    const router = (0,next_router.useRouter)();
    const slug = router.query.slug ?? "";
    const { 0: studyLevelOptions , 1: setStudyLevelOptions  } = (0,react.useState)([]);
    const { 0: scholarshipTypeOptions , 1: setScholarshipTypeOptions  } = (0,react.useState)([]);
    const { 0: scholarshipType , 1: setScholarshipType  } = (0,react.useState)(null);
    const { 0: studyLevel , 1: setStudyLevel  } = (0,react.useState)([]);
    const { 0: universitySearchTerm , 1: setUniversitySearchTerm  } = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/new-country-specific-scholarships/program-filters?slug=${slug}`, "GET", {}, "", false).then((res)=>{
            const toOptions = (values = [])=>values.map((value)=>({
                        label: value,
                        value
                    }));
            setStudyLevelOptions(toOptions(res?.studyLevel));
            setScholarshipTypeOptions(toOptions(res?.type));
        });
    }, []);
    const scholarshipTypeSelectHandler = (option)=>{
        setScholarshipType(option);
        searchClickHandler({
            scholarshipType: option
        });
    };
    const studyLevelSelectHandler = (selectedOptions)=>{
        setStudyLevel(selectedOptions);
        searchClickHandler({
            studyLevel: selectedOptions
        });
    };
    const buildSearchQuery = (overrides = {})=>{
        const effectiveStudyLevel = overrides.studyLevel ?? studyLevel;
        const effectiveScholarshipType = "scholarshipType" in overrides ? overrides.scholarshipType : scholarshipType;
        const effectiveUniversitySearchTerm = overrides.universitySearchTerm ?? universitySearchTerm;
        const params = new URLSearchParams({
            slug: slug
        });
        if (effectiveStudyLevel.length) params.set("studyLevelMultiSelect", effectiveStudyLevel.map((option)=>option.value).join(","));
        if (effectiveScholarshipType?.value) params.set("type", effectiveScholarshipType.value);
        if (effectiveUniversitySearchTerm) params.set("subTitle", effectiveUniversitySearchTerm);
        return params.toString();
    };
    const searchClickHandler = (overrides = {})=>{
        setLoading(true);
        setSearchedUni(overrides.universitySearchTerm ?? universitySearchTerm);
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/new-country-specific-scholarships/search-programs?${buildSearchQuery(overrides)}`, "GET", {}, "", false).then((res)=>{
            setScholarships(res ?? []);
        }).finally(()=>{
            setLoading(false);
        });
    };
    const debouncedSearch = (0,useDebounce/* default */.Z)((value)=>{
        searchClickHandler({
            universitySearchTerm: value
        });
    });
    const inputChangeHandler = (e)=>{
        const value = e.target.value;
        setUniversitySearchTerm(value);
        debouncedSearch(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (FilterCard_module_default()).filterCardContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FilterCard_module_default()).filterCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FilterCard_module_default()).row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                            options: studyLevelOptions,
                            multiple: true,
                            selectedValues: studyLevel,
                            placeholder: "Study Level",
                            onSelectionChange: studyLevelSelectHandler
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                            options: scholarshipTypeOptions,
                            value: scholarshipType,
                            showClear: true,
                            placeholder: "Type of Scholarship",
                            onChange: scholarshipTypeSelectHandler,
                            onClear: ()=>{
                                setScholarshipType(null);
                                searchClickHandler({
                                    scholarshipType: null
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FilterCard_module_default())["search-input-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: (FilterCard_module_default()).searchInput,
                            value: universitySearchTerm,
                            placeholder: "Search by University..",
                            onChange: inputChangeHandler,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter") {
                                    debouncedSearch.cancel();
                                    searchClickHandler();
                                }
                            }
                        }),
                        universitySearchTerm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FilterCard_module_default()).crossIconContainer,
                            onClick: ()=>{
                                setUniversitySearchTerm("");
                                debouncedSearch.cancel();
                                searchClickHandler({
                                    universitySearchTerm: ""
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon/* default */.Z, {
                                width: 12,
                                height: 12,
                                color: "#64647A"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FilterCard_FilterCard = (FilterCard);

// EXTERNAL MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/ScholarshipList/ScholarshipCard/ScholarshipCard.module.scss
var ScholarshipCard_module = __webpack_require__(45224);
var ScholarshipCard_module_default = /*#__PURE__*/__webpack_require__.n(ScholarshipCard_module);
// EXTERNAL MODULE: ./components/UI/Icons/FeatherNote.tsx
var FeatherNote = __webpack_require__(31331);
// EXTERNAL MODULE: ./components/UI/Icons/DollarEnclosed.tsx
var DollarEnclosed = __webpack_require__(67316);
// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/ScholarshipList/ScholarshipCard/ScholarshipCard.tsx








const ScholarshipCard = /*#__PURE__*/ (0,react.forwardRef)(({ cardData , minHeight  }, ref)=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (ScholarshipCard_module_default()).card,
        style: !isMobile && minHeight ? {
            minHeight
        } : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ScholarshipCard_module_default())["logo-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                    src: cardData?.image?.url ?? "",
                    alt: "University logo",
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ScholarshipCard_module_default())["card-content"],
                children: [
                    cardData?.subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ScholarshipCard_module_default()).university,
                        children: cardData?.subTitle
                    }),
                    cardData?.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ScholarshipCard_module_default())["card-title"],
                        children: cardData?.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ScholarshipCard_module_default()).meta,
                        children: [
                            cardData?.type && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ScholarshipCard_module_default())["type-row"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatherNote/* default */.Z, {
                                        width: 19,
                                        height: 19
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Scholarship Type : ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: cardData?.type
                                            })
                                        ]
                                    })
                                ]
                            }),
                            cardData?.amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ScholarshipCard_module_default())["type-row"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DollarEnclosed/* default */.Z, {
                                        width: 19,
                                        height: 19
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Amount : ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: cardData?.amount
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    cardData?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ScholarshipCard_module_default()).description,
                        children: cardData?.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: `${(ScholarshipCard_module_default())["apply-btn"]} ${cardData?.btnLink ? "" : (0,helpers/* isFrappeOrJotFormClass */.gd)(cardData?.formId ?? "")}`,
                onClick: ()=>{
                    cardData?.btnLink && window.open(cardData?.btnLink, "_blank");
                },
                children: cardData?.btnLabel || "View & Apply "
            })
        ]
    });
});
/* harmony default export */ var ScholarshipCard_ScholarshipCard = (ScholarshipCard);

// EXTERNAL MODULE: ./components/UI/Pagination/Pagination.module.scss
var Pagination_module = __webpack_require__(48065);
var Pagination_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_module);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
;// CONCATENATED MODULE: ./components/UI/Pagination/Pagination.tsx




const Pagination = ({ currentPage , totalPages , onPageChange  })=>{
    const leftBtnClickHandler = ()=>{
        if (currentPage === 1) return;
        onPageChange(currentPage - 1);
    };
    const rightBtnClickHandler = ()=>{
        if (currentPage === totalPages) return;
        onPageChange(currentPage + 1);
    };
    const pageBtnClickHandler = (page)=>()=>{
            onPageChange(page);
        };
    if (totalPages <= 1) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Pagination_module_default())["pagination-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: `${(Pagination_module_default())["pagination-left-button"]} ${currentPage === 1 ? (Pagination_module_default())["button-disabled"] : ""}`,
                onClick: leftBtnClickHandler,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Pagination_module_default())["pagination-page-buttons-container"],
                children: Array(totalPages).fill(0).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: `${(Pagination_module_default())["pagination-page-button"]} ${currentPage === index + 1 ? (Pagination_module_default())["pagination-page-button-active"] : ""}`,
                        style: currentPage > 3 ? {
                            transform: `translateX(-${(currentPage - 2) * 64}px)`
                        } : {},
                        onClick: pageBtnClickHandler(index + 1),
                        children: index + 1
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: `${(Pagination_module_default())["pagination-right-button"]} ${currentPage === totalPages ? (Pagination_module_default())["button-disabled"] : ""}`,
                onClick: rightBtnClickHandler,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var Pagination_Pagination = (Pagination);

// EXTERNAL MODULE: ./components/UI/Spinner/Spinner.tsx
var Spinner = __webpack_require__(63098);
// EXTERNAL MODULE: ./components/EnquiryModal/LeadGenForms.tsx + 2 modules
var LeadGenForms = __webpack_require__(59833);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/ScholarshipList/ScholarshipList.tsx











const CARDS_PER_PAGE = 10;
const ScholarshipList = ({ scholarshipCountryData , scholarshipsPrograms , searchScholarship  })=>{
    const isTab = (0,useIsMobile/* default */.Z)(1024);
    const isMobile = (0,useIsMobile/* default */.Z)(600);
    const { 0: currentPage , 1: setCurrentPage  } = (0,react.useState)(1);
    const { 0: scholarships , 1: setScholarships  } = (0,react.useState)([]);
    const { 0: searchedUni , 1: setSearchedUni  } = (0,react.useState)("");
    const { 0: loading , 1: setLoading  } = (0,react.useState)(false);
    const { 0: maxCardHeight , 1: setMaxCardHeight  } = (0,react.useState)(undefined);
    const cardRefs = (0,react.useRef)([]);
    const totalPages = Math.ceil(scholarships.length / CARDS_PER_PAGE);
    const paginatedScholarships = scholarships.slice((currentPage - 1) * CARDS_PER_PAGE, currentPage * CARDS_PER_PAGE);
    (0,react.useLayoutEffect)(()=>{
        setMaxCardHeight(undefined);
    }, [
        currentPage,
        scholarships,
        isTab,
        isMobile
    ]);
    (0,react.useLayoutEffect)(()=>{
        if (maxCardHeight !== undefined) return;
        const heights = cardRefs.current.map((el)=>el?.offsetHeight ?? 0);
        if (heights.length) setMaxCardHeight(Math.max(...heights));
    }, [
        maxCardHeight,
        currentPage,
        scholarships
    ]);
    (0,react.useEffect)(()=>setCurrentPage(1), [
        scholarships
    ]);
    (0,react.useEffect)(()=>{
        setScholarships(scholarshipsPrograms?.popularCountryPrograms ?? []);
    }, [
        scholarshipsPrograms
    ]);
    const adClickHandler = (link)=>()=>{
            window.open(link, "_blank");
        };
    const adPanel = scholarshipCountryData?.adPanel;
    const getAdProps = (baseClass)=>({
            className: [
                baseClass,
                adPanel?.link || adPanel?.formId ? (ScholarshipList_module_default())["is-clickable"] : "",
                !adPanel?.link && adPanel?.formId ? (0,helpers/* isFrappeOrJotFormClass */.gd)(adPanel?.formId) : "", 
            ].filter(Boolean).join(" "),
            onClick: adPanel?.link ? adClickHandler(adPanel.link) : undefined
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (ScholarshipList_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ScholarshipList_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (ScholarshipList_module_default()).heading,
                    children: searchScholarship?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCard_FilterCard, {
                    setScholarships: setScholarships,
                    setSearchedUni: setSearchedUni,
                    setLoading: setLoading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ScholarshipList_module_default())["results-area"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ScholarshipList_module_default())["results-grid"],
                        children: [
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ScholarshipList_module_default()).loadingContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
                            }),
                            !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ScholarshipList_module_default())["results-main"],
                                children: [
                                    isMobile && scholarshipCountryData?.adPanel?.img?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ...getAdProps((ScholarshipList_module_default())["sidebar-ad-mobile"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: scholarshipCountryData?.adPanel?.img?.url ?? "",
                                            layout: "fill",
                                            objectFit: "fill",
                                            alt: "ad-panel-img"
                                        })
                                    }),
                                    isTab && !isMobile && scholarshipCountryData?.adPanel?.img?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ...getAdProps((ScholarshipList_module_default())["sidebar-ad-tab"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: scholarshipCountryData?.adPanel?.tabImg?.url ?? "",
                                            layout: "fill",
                                            objectFit: "fill",
                                            alt: "ad-panel-img"
                                        })
                                    }),
                                    searchedUni?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            scholarships.length,
                                            " scholarships found for",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    ' "',
                                                    searchedUni,
                                                    '"'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ScholarshipList_module_default())["cards-list"],
                                        children: paginatedScholarships.length > 0 && paginatedScholarships.map((scholarship, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ScholarshipCard_ScholarshipCard, {
                                                cardData: scholarship,
                                                minHeight: maxCardHeight,
                                                ref: (el)=>cardRefs.current[index] = el
                                            }, scholarship?.id ?? index))
                                    }),
                                    searchedUni.length === 0 && scholarships.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (ScholarshipList_module_default())["empty-list-msg"],
                                        children: "No scholarships found !"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_Pagination, {
                                        currentPage: currentPage,
                                        totalPages: totalPages,
                                        onPageChange: setCurrentPage
                                    })
                                ]
                            }),
                            !isTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ScholarshipList_module_default()).sidebar,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ScholarshipList_module_default())["sidebar-form"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ScholarshipList_module_default()).jotFormHeader,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: (ScholarshipList_module_default())["form-title"],
                                                        children: "Want to Study Abroad?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Fill in your details and our experts will guide you to the best scholarship opportunities."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGenForms/* default */.Z, {
                                                mode: "inline",
                                                url: "https://crm.coursefinder.ai" + "/" + scholarshipCountryData?.sidebarFormId,
                                                wrapperClass: (ScholarshipList_module_default()).inLineFormUniversity,
                                                loader: "shimmer"
                                            })
                                        ]
                                    }),
                                    adPanel?.img?.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ...getAdProps((ScholarshipList_module_default())["sidebar-ad-desktop"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: adPanel?.img?.url ?? "",
                                            layout: "fill",
                                            objectFit: "cover",
                                            alt: "ad-panel-img"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ScholarshipList_ScholarshipList = (ScholarshipList);

// EXTERNAL MODULE: ./components/ScholarshipsPage/ReceviedScholarships/ReceviedScholarships.tsx
var ReceviedScholarships = __webpack_require__(64171);
// EXTERNAL MODULE: ./components/ScholarshipsPage/FAQs/FAQs.tsx
var FAQs = __webpack_require__(57866);
// EXTERNAL MODULE: ./components/ScholarshipsPage/Banner1/Banner1.tsx
var Banner1 = __webpack_require__(78808);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/CountrySpecificScholarship/CountrySpecificScholarship.tsx







const CountrySpecificScholarship = (props)=>{
    const scholarshipCountryData = props.pageData?.[0];
    const topScholarships = scholarshipCountryData?.topScholarships ?? {};
    const faqData = scholarshipCountryData?.faq ?? {};
    const bannerData = scholarshipCountryData?.banner ?? {};
    const scholarshipsPrograms = scholarshipCountryData?.scholarshipsPrograms ?? {};
    const searchScholarship = scholarshipCountryData?.searchScholarship ?? {};
    const hasData = (obj)=>Object.keys(obj).length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "countrySholarshipsPage",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                    scholarshipCountryData: scholarshipCountryData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScholarshipList_ScholarshipList, {
                    scholarshipCountryData: scholarshipCountryData,
                    scholarshipsPrograms: scholarshipsPrograms,
                    searchScholarship: searchScholarship
                }),
                hasData(topScholarships) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceviedScholarships/* default */.Z, {
                    topScholarships: topScholarships
                }),
                hasData(faqData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                    faqData: faqData
                }),
                hasData(bannerData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner1/* default */.Z, {
                    bannerData: bannerData
                })
            ]
        })
    });
};
/* harmony default export */ var CountrySpecificScholarship_CountrySpecificScholarship = (CountrySpecificScholarship);

;// CONCATENATED MODULE: ./pages/student-services/study-abroad-scholarships/[slug].tsx






const ScholarshipCountry = (props)=>{
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
    }
    const { meta  } = props.pageData?.[0];
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6c48f0");
        customStyle.setProperty("--navbar-menu-color", "#FFFFFF");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            props.mode === "newUI" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountrySpecificScholarship_CountrySpecificScholarship, {
                ...props
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ScholarshipCountryComponent, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (ScholarshipCountry);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 76604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner_hide-scrollbar__wUm_f","banner-container-wrapper":"Banner_banner-container-wrapper__FH34m","banner-container":"Banner_banner-container__dfXxn","image-wrapper":"Banner_image-wrapper__DbE96","priority-image-container":"Banner_priority-image-container__Eof0j"};

/***/ }),

/***/ 85307:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner1_hide-scrollbar__RcLoc","banner-section-wrapper":"Banner1_banner-section-wrapper__grJxN","banner-container":"Banner1_banner-container__n3evD","banner-1-container":"Banner1_banner-1-container__4RUVv","content-container":"Banner1_content-container__rmHkt","actions-container":"Banner1_actions-container__BvVeL","kc-letter-container":"Banner1_kc-letter-container__75B1q","contact-us-btn":"Banner1_contact-us-btn__5M1Nk","enquire-now-btn":"Banner1_enquire-now-btn__9Yq_6"};

/***/ }),

/***/ 26666:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HeroSection_hide-scrollbar__dDwF3","countrySholarshipsPage":"HeroSection_countrySholarshipsPage__fjNyS","breadcrum-container":"HeroSection_breadcrum-container__TP3jC","heading":"HeroSection_heading__O3dMm","description":"HeroSection_description__uIiC_","ctaBtn":"HeroSection_ctaBtn__G6hEP","kunai1":"HeroSection_kunai1__DJe1q","kunai2":"HeroSection_kunai2__icu5r","kunai3":"HeroSection_kunai3__dXB4q","dot1":"HeroSection_dot1__htmci","dot2":"HeroSection_dot2__NEaBM","empty-circle":"HeroSection_empty-circle__S2SVh"};

/***/ }),

/***/ 50865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FilterCard_hide-scrollbar__lXtCb","filterCardContainer":"FilterCard_filterCardContainer__CaM4B","filterCard":"FilterCard_filterCard__Wx_k6","row":"FilterCard_row__w9C64","searchInput":"FilterCard_searchInput__66iDT","search-input-container":"FilterCard_search-input-container__VHNji","crossIconContainer":"FilterCard_crossIconContainer__qt_tq","searchBtn":"FilterCard_searchBtn__uP1Tv"};

/***/ }),

/***/ 45224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ScholarshipCard_hide-scrollbar__4MDJS","card":"ScholarshipCard_card__bVLjB","logo-wrapper":"ScholarshipCard_logo-wrapper__0wk88","card-content":"ScholarshipCard_card-content__AwjXP","university":"ScholarshipCard_university__pn9Qs","card-title":"ScholarshipCard_card-title__rU54X","meta":"ScholarshipCard_meta__puhpp","type-row":"ScholarshipCard_type-row__KHm2E","description":"ScholarshipCard_description__XZ5_H","apply-btn":"ScholarshipCard_apply-btn__zmpxs"};

/***/ }),

/***/ 69122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ScholarshipList_hide-scrollbar__5GLLY","section":"ScholarshipList_section__l3Kj_","content":"ScholarshipList_content__Mi96f","heading":"ScholarshipList_heading__rBzI6","results-area":"ScholarshipList_results-area__mlmWG","results-grid":"ScholarshipList_results-grid__KCdeo","loadingContainer":"ScholarshipList_loadingContainer__BhbNg","results-main":"ScholarshipList_results-main__W_yfJ","cards-list":"ScholarshipList_cards-list__mDXgK","empty-list-msg":"ScholarshipList_empty-list-msg__MBrTi","sidebar":"ScholarshipList_sidebar__xgV7s","sidebar-form":"ScholarshipList_sidebar-form__NjP_T","jotFormHeader":"ScholarshipList_jotFormHeader__8B_zL","form-title":"ScholarshipList_form-title__KqwGW","inLineFormUniversity":"ScholarshipList_inLineFormUniversity__hfHEN","sidebar-ad-desktop":"ScholarshipList_sidebar-ad-desktop__W8YZ4","is-clickable":"ScholarshipList_is-clickable__oKxe4","sidebar-ad-mobile":"ScholarshipList_sidebar-ad-mobile__g3AX6","sidebar-ad-tab":"ScholarshipList_sidebar-ad-tab__0WWTK"};

/***/ }),

/***/ 20252:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FAQs_hide-scrollbar__89ZH6","faq-section":"FAQs_faq-section__evhQ6","faq-container":"FAQs_faq-container__S5dao","faq-heading":"FAQs_faq-heading__Zbi8v","faq-subtext":"FAQs_faq-subtext__jIOs1"};

/***/ }),

/***/ 56303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ReceviedScholarships_hide-scrollbar__UdtTB","rs-section":"ReceviedScholarships_rs-section__Y4lAg","rs-container":"ReceviedScholarships_rs-container__JOTI7","rs-heading":"ReceviedScholarships_rs-heading__4wPW7","rs-carousel-wrap":"ReceviedScholarships_rs-carousel-wrap__3R6xK","rs-arrow-side":"ReceviedScholarships_rs-arrow-side__2VJ9_","rs-viewport":"ReceviedScholarships_rs-viewport__tM6xk","rs-slider":"ReceviedScholarships_rs-slider__jkQ55","rs-arrows-below":"ReceviedScholarships_rs-arrows-below__B0RLc","rs-dots":"ReceviedScholarships_rs-dots__LtV2o","rs-dot":"ReceviedScholarships_rs-dot__sc7iL","rs-dot-active":"ReceviedScholarships_rs-dot-active__leLly","rs-slide":"ReceviedScholarships_rs-slide__YuYYX","rs-card":"ReceviedScholarships_rs-card__9xx4Y","rs-avatar-wrap":"ReceviedScholarships_rs-avatar-wrap__WbIAK","rs-avatar":"ReceviedScholarships_rs-avatar__7eFuh","rs-name":"ReceviedScholarships_rs-name__nVn78","rs-details":"ReceviedScholarships_rs-details__pZ_d_","rs-label":"ReceviedScholarships_rs-label__UzNUQ","rs-arrow":"ReceviedScholarships_rs-arrow__aKKjJ"};

/***/ }),

/***/ 48065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Pagination_hide-scrollbar__bb5Ms","pagination-container":"Pagination_pagination-container__48NaG","pagination-page-buttons-container":"Pagination_pagination-page-buttons-container__1KDyf","pagination-page-button":"Pagination_pagination-page-button__XYmAF","pagination-page-button-active":"Pagination_pagination-page-button-active__h_Mt_","pagination-left-button":"Pagination_pagination-left-button__191Bb","button-disabled":"Pagination_button-disabled__1xfA6"};

/***/ }),

/***/ 28154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__gcxKa","spin":"Spinner_spin__p0RVb"};

/***/ }),

/***/ 79373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__5J6pK","clip":"Error_clip__SVATU","shadow":"Error_shadow__FSdAk","main":"Error_main__RrWpw","digit":"Error_digit__HcJVc","btndiv":"Error_btndiv__gV_0s","btnPrimary":"Error_btnPrimary__RVY52","msg":"Error_msg__ksdYX","triangle":"Error_triangle__qa4xL","containerError404":"Error_containerError404__DhF_F"};

/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ }),

/***/ 76817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrum":"ScholarshipsCountry_breadcrum__XJFbd","scholarshipPrograms":"ScholarshipsCountry_scholarshipPrograms__w_yfg","countrySholarshipsPage":"ScholarshipsCountry_countrySholarshipsPage__okWwC","parentMain":"ScholarshipsCountry_parentMain__Socx5","borderRadiusImg":"ScholarshipsCountry_borderRadiusImg__jSoyv","enquirebtn":"ScholarshipsCountry_enquirebtn__ayv_e","heading":"ScholarshipsCountry_heading__IW5J8","buttongp":"ScholarshipsCountry_buttongp__ebBZV","kcbtn":"ScholarshipsCountry_kcbtn__m2noS","centered":"ScholarshipsCountry_centered__L_VGA","breadcrumb-item":"ScholarshipsCountry_breadcrumb-item__20bXV","active":"ScholarshipsCountry_active__3nvOf","mainTitle":"ScholarshipsCountry_mainTitle__u3ogV","introduction":"ScholarshipsCountry_introduction__Hp0_c","para":"ScholarshipsCountry_para__tf8JB","applyNow":"ScholarshipsCountry_applyNow__putff","popularScholarshipPrograms":"ScholarshipsCountry_popularScholarshipPrograms__YGZgf","sliderPosition":"ScholarshipsCountry_sliderPosition__W7gXc","programSlider":"ScholarshipsCountry_programSlider__xmXjq","card":"ScholarshipsCountry_card__0EhYg","cardBody":"ScholarshipsCountry_cardBody__GrWHT","program":"ScholarshipsCountry_program__SAOEk","cardImg":"ScholarshipsCountry_cardImg__fOCDP","title":"ScholarshipsCountry_title__i2PH6","content":"ScholarshipsCountry_content__yfZ60","detail":"ScholarshipsCountry_detail__fshND","viewMore":"ScholarshipsCountry_viewMore__UMkNo","mobileCard":"ScholarshipsCountry_mobileCard__0tFkp","mobileCardBody":"ScholarshipsCountry_mobileCardBody__ujoE9","mobileProgramDetails":"ScholarshipsCountry_mobileProgramDetails__JyOnW","mobileCardHeader":"ScholarshipsCountry_mobileCardHeader__5Uxvh","sliderDots":"ScholarshipsCountry_sliderDots__cE_F5","mobileSliderDots":"ScholarshipsCountry_mobileSliderDots__3svBy","activeClass":"ScholarshipsCountry_activeClass__HXpcs","arrowsClass":"ScholarshipsCountry_arrowsClass__v0y2B","btcircle":"ScholarshipsCountry_btcircle__WaEBG","floatRight":"ScholarshipsCountry_floatRight__b5Qef","floatLeft":"ScholarshipsCountry_floatLeft__qa_9m"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 49059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,9382,474,3213,6985,9774,2888,179], function() { return __webpack_exec__(1027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);